import { render } from "./FeatureSelectionPage.vue?vue&type=template&id=162845f4&scoped=true"
import script from "./FeatureSelectionPage.vue?vue&type=script&lang=js"
export * from "./FeatureSelectionPage.vue?vue&type=script&lang=js"

import "./FeatureSelectionPage.vue?vue&type=style&index=0&id=162845f4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162845f4"]])

export default __exports__